document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".ew-slider");

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const stopAnim = (el) => {
    if (!el) return;
    el.getAnimations?.().forEach((a) => a.cancel());
  };

  const fadeSwapImage = async (img, nextSrc) => {
  if (!img || !nextSrc) return;

  const current = img.getAttribute("src");
  if (current === nextSrc) return;

  if (reduceMotion) {
    img.src = nextSrc;
    return;
  }

  // 1) preload next image (чтобы не было "резкой подмены")
  const pre = new Image();
  pre.src = nextSrc;

  const preloadDone = (async () => {
    // decode быстрее/чище, но может бросать — поэтому fallback
    if (pre.decode) {
      try { await pre.decode(); return; } catch (e) {}
    }
    await new Promise((res) => {
      pre.addEventListener("load", res, { once: true });
      pre.addEventListener("error", res, { once: true });
    });
  })();

  // 2) fade out текущей
  stopAnim(img);
  const out = img.animate([{ opacity: 1 }, { opacity: 0 }], {
    duration: 220,
    easing: "ease-out",
    fill: "forwards",
  });

  // ждём и затухание, и прелоад
  await Promise.allSettled([out.finished, preloadDone]);

  // 3) жёстко фиксируем opacity=0, чтобы не было "мигания" при swap
  stopAnim(img);
  img.style.opacity = "0";

  // 4) swap src (картинка уже в кеше)
  img.src = nextSrc;

  // 5) fade in
  const inn = img.animate([{ opacity: 0 }, { opacity: 1 }], {
    duration: 280,
    easing: "ease-out",
    fill: "forwards",
  });

  await inn.finished.catch(() => {});
  // можно оставить fill:forwards, но чтобы не копить inline-стили:
  img.style.opacity = "";
};

  const animatePanelOpen = (panel) => {
    if (!panel) return Promise.resolve();
    stopAnim(panel);

    panel.hidden = false;

    const endH = panel.scrollHeight;
    panel.style.overflow = "hidden";
    panel.style.height = "0px";

    const anim = panel.animate(
      [{ height: "0px", opacity: 0 }, { height: `${endH}px`, opacity: 1 }],
      { duration: 320, easing: "cubic-bezier(.2,.8,.2,1)" }
    );

    const cleanup = () => {
      panel.style.height = "";
      panel.style.overflow = "";
    };

    anim.onfinish = cleanup;
    anim.oncancel = cleanup;

    return anim.finished.catch(() => {});
  };

  const animatePanelClose = (panel) => {
    if (!panel || panel.hidden) return Promise.resolve();
    stopAnim(panel);

    const startH = panel.scrollHeight;
    panel.style.overflow = "hidden";
    panel.style.height = `${startH}px`;

    const anim = panel.animate(
      [{ height: `${startH}px`, opacity: 1 }, { height: "0px", opacity: 0 }],
      { duration: 260, easing: "cubic-bezier(.4,0,.2,1)" }
    );

    const cleanup = () => {
      panel.hidden = true;
      panel.style.height = "";
      panel.style.overflow = "";
    };

    anim.onfinish = cleanup;
    anim.oncancel = cleanup;

    return anim.finished.catch(() => {});
  };

  sliders.forEach((root) => {
    const img = root.querySelector("[data-ew-slider-image]");
    const tabs = Array.from(root.querySelectorAll("[data-ew-slider-tab]"));
    const panels = Array.from(root.querySelectorAll(".ew-slider__panel"));

    if (!tabs.length) return;

    let actionId = 0;

    const setActive = async (slideNum, { immediate = false } = {}) => {
      actionId += 1;
      const myAction = actionId;

      const activeTab = tabs.find(t => t.dataset.slide === String(slideNum)) || tabs[0];
      const panelId = activeTab.getAttribute("aria-controls");

      // Tabs
      tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      // Panels
      const anims = [];
      panels.forEach((panel) => {
        const shouldBeActive = panel.id === panelId;
        panel.classList.toggle("is-active", shouldBeActive);

        if (immediate || reduceMotion) {
          stopAnim(panel);
          panel.hidden = !shouldBeActive;
          panel.style.height = "";
          panel.style.overflow = "";
        } else {
          if (shouldBeActive) anims.push(animatePanelOpen(panel));
          else anims.push(animatePanelClose(panel));
        }
      });

      if (!immediate && !reduceMotion) {
        await Promise.allSettled(anims);
      }
      if (myAction !== actionId) return;

      // Image: берем из data-ew-slider-src внутри активной панели
      const activePanel = panels.find(p => p.id === panelId);
      const nextSrc = activePanel
        ?.querySelector("[data-ew-slider-src]")
        ?.dataset.ewSliderSrc
        ?.trim();

      if (nextSrc) {
        await fadeSwapImage(img, nextSrc);
      }
    };

    // init: first active
    setActive(1, { immediate: true });

    // Click
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const slideNum = Number(tab.dataset.slide || "1");
        setActive(slideNum);
      });
    });

    // Keyboard (left/right)
    root.querySelector(".ew-slider__controls")?.addEventListener("keydown", (e) => {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;

      const activeIndex = tabs.findIndex((t) => t.classList.contains("is-active"));
      const dir = e.key === "ArrowRight" ? 1 : -1;
      const nextIndex = (activeIndex + dir + tabs.length) % tabs.length;

      e.preventDefault();
      tabs[nextIndex].focus();
      setActive(Number(tabs[nextIndex].dataset.slide || "1"));
    });
  });
});